/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const WorkflowJobQueueJsonApiModel = {
  id: "",
  name: "",
  size: "",
  priority: "",
  disabled: "",
  "stop-on-error": "",
  "created-at": "",
  "updated-at": "",
};
